/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { PromotionDto } from './data-contracts';
import { HttpClient, RequestParams } from './http-client';

export class PromotionService<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags PromotionService
   * @name GetPromotions
   * @summary Get Promotions
   * @request GET:/v1/promotions
   * @secure
   */
  getPromotions = (
    query: {
      searchKeyword?: string;
      /**
       * Zero-based page index (0..N)
       * @min 0
       * @default 0
       */
      page?: number;
      /**
       * The size of the page to be returned
       * @min 1
       * @default 20
       */
      size?: number;
      /** Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported. */
      sort?: string[];
      locale: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<PromotionDto[], any>({
      path: `/v1/promotions`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PromotionService
   * @name GetPromotion
   * @summary Get Promotion by ID
   * @request GET:/v1/promotions/{promotionId}
   * @secure
   */
  getPromotion = (
    promotionId: number,
    query: {
      locale: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<PromotionDto, any>({
      path: `/v1/promotions/${promotionId}`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
}
